import contentRequest from '~/src/api/requests/contentRequest';
import { REQUEST_TIMEOUT } from '~/src/constants';
/**
 * Получение документов из api-content
 * @param {Number} providerId
 * @param {String} categoryId
 * @returns {Promise<any|undefined>}
 */
export async function getDocuments(providerId, categoryId) {
    const params = {
        'filter[category_id]': categoryId,
        providerId,
    };
    return contentRequest.get('/v1/documents', {
        params,
        timeout: REQUEST_TIMEOUT,
    }).then(response => {
            return response.data.items;
        })
        .catch(e => console.error('contentRequest for documents error:', e));
}
